// Login.js
import React from "react";
import { FaGoogle } from "react-icons/fa";
import useSocialMedia from "../../../hooks/useSocialMedia";
import { useModal } from "../../../hooks/useModal";

export default function Login() {
  const { handleGoogleLogin } = useSocialMedia();
  const { closeModal } = useModal();

  return (
    <div className="login-buttons">
      <button
        className="login-provider-button google-btn"
        onClick={() => handleGoogleLogin({ handleCloseForm: closeModal })}
      >
        <FaGoogle className="icon" />
        <span>Continue with Google</span>
      </button>
    </div>
  );
}
